import { PaletteMode } from '@mui/material';
import { createTheme, Theme } from '@mui/material/styles';
import { csCZ, enUS } from '@mui/material/locale';
import { Locale } from '../i18n/locale';

import { darkPalette, DARK_BACKGROUND, lightPalette } from './palette';

export { DARK_BACKGROUND } from './palette';

const createBaseTheme = (mode: PaletteMode) =>
  createTheme({
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 24,
            boxShadow: 'none',
            fontWeight: 600,
            textTransform: 'none',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          rounded: {
            borderRadius: 8,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 7,
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          inputRoot: {
            paddingTop: 1,
            paddingBottom: 1,
            '.MuiOutlinedInput-notchedOutline': {
              borderRadius: 'inherit',
            },
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          input: ({ theme }) => ({
            padding: '8px 12px',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderRadius: 2,
            borderColor: theme.palette.outline,
          }),
        },
        defaultProps: {
          disableUnderline: true,
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: ({ theme }) => ({
            color: theme.palette.text.secondary,
          }),
        },
      },
    },
    palette: mode === 'dark' ? darkPalette : lightPalette,
    typography: {
      fontFamily: "'Figtree', sans-serif",
    },
  });

export const createAppTheme = (mode: PaletteMode, locale: Locale = 'en') =>
  createTheme(createBaseTheme(mode), locale === 'cs' ? csCZ : enUS);

export const resetStyles = (theme: Theme) => `
body,
html,
#root {
  width: 100%;
  height: 100%;
}

body {
  margin: 0;
  background-color: ${theme.palette.background.default};
  color: ${theme.palette.text.primary};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Figtree', sans-serif, -apple-system, BlinkMacSystemFont,
    'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
    'Droid Sans', 'Helvetica Neue', sans-serif;
}

html[data-color-mode='dark'] body {
  background-color: ${DARK_BACKGROUND};
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`;
